// ---------------------------------------------------------------------------
// پلاگین‌های مشترک Chart.js
// ---------------------------------------------------------------------------

/**
 * خط مبنای صفر — یک خط‌چین افقی روی مقدار صفر محور Y رسم می‌کند تا تمایز
 * مقادیر مثبت و منفی مشخص شود. اگر صفر خارج از محدوده‌ی نمودار باشد رسم نمی‌شود.
 * رنگ به‌صورت theme-aware از متغیر CSS خوانده می‌شود.
 */
export const zeroBaselinePlugin = {
  id: 'zeroBaseline',
  afterDatasetsDraw(chart: any) {
    const yScale = chart.scales?.y;
    if (!yScale) return;
    const y = yScale.getPixelForValue(0);
    const { ctx, chartArea } = chart;
    if (!chartArea || y < chartArea.top || y > chartArea.bottom) return;
    const color =
      (typeof window !== 'undefined' &&
        getComputedStyle(document.documentElement).getPropertyValue('--text-secondary').trim()) ||
      '#64748b';
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(chartArea.left, y);
    ctx.lineTo(chartArea.right, y);
    ctx.lineWidth = 1.5;
    ctx.strokeStyle = color;
    ctx.setLineDash([5, 4]);
    ctx.stroke();
    ctx.restore();
  },
};
